import React, { useEffect, useState } from "react";
import { axios } from "../../../../Global";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";
import LisDataVisaReport from "./ListDataVisaReport";
import LoadingWithLable from "../../../../ReusableComponents/Loading/LoadingWithLable";

export default function VisaReport() {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const [reportData, setReportData] = useState([]);
  const [filteredReportData, setFilteredReportData] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [allVisaProviders, setAllVisaProviders] = useState([]);
  const [allJobPosition, setAllJobPosition] = useState([]);
  const [allCountry, setAllCountry] = useState([]);
  const [allVisaProfession, setAllVisaProfession] = useState([]);
  const [allClients, setAllClients] = useState([]);

  useEffect(() => {
    axios
      .get("/dashboard/visa-report", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setReportData(res.data?.data?.visa_report);
        setFilteredReportData(res.data?.data?.visa_report);
        console.log(',dd',res.data?.data?.visa_report);
        
        setAllProjects(res.data?.data?.project);
        setAllVisaProviders(res.data?.data?.company);
        setAllVisaProfession(res.data?.data?.visa_profession);
        setAllJobPosition(res.data?.data?.job_position);
        setAllCountry(res.data?.data?.nationality);
      })
      .catch((err) => {
        dispatch(setAppError({ msg: err.message || "Something went wrong" }));
      });
  }, []);

  return (
    <>
      {reportData.length > 0 ? (
        <div className={`p-2  sm:p-5 `}>
          <LisDataVisaReport
            reportData={reportData}
            filteredReportData={filteredReportData}
            setFilteredReportData={setFilteredReportData}
            allProjects={allProjects}
            allCountry={allCountry}
            allJobPosition={allJobPosition}
            allVisaProfession={allVisaProfession}
            allVisaProviders={allVisaProviders}
          />
        </div>
      ) : (
        <LoadingWithLable />
      )}
    </>
  );
}
